<div class="breadcrumb-container" [ngClass]="{ 'breadcrumb-container-compact': compactSidebar }" id="breadcrumb">
  <div class="breadcrumb-component">
    <app-breadcrumb
      [parents]=breadcrumbParents
      [self]="breadcrumbSelf">
    </app-breadcrumb>
  </div>
  <div class="breadcrumb-menu">
    <app-survey-record-breadcrumb-buttons
      [readonly]="true"
      [allowClone]="true"
      [allowExport]="true"
      [surveyId]="surveyId"
      [surveyRecordId]="surveyRecordId"
      [form]="f">
    </app-survey-record-breadcrumb-buttons>
  </div>
</div>
<div class="breadcrumb-placeholder"></div>
<div class="container-horizontal-padding container-vertical-padding-half animated fadeIn">
  <form class="form-horizontal bordered-row" (ngSubmit)="nothing()" #f="ngForm" novalidate>
    <app-survey-record-base
      headingDictionaryKey="SURVEY_RECORD_PANEL_HEADING_DETAIL"
      [readonly]="true"
      [allowClone]="true"
      [allowExport]="true"
      [form]="f"></app-survey-record-base>
    <app-form-record-container
      [readonly]="true"
      [cloning]="false"
      [form]="f"></app-form-record-container>
  </form>
</div>
